// Numeric input that surfaces null/empty cleanly. Internally an HTML
// number input; passes back `null` when the user clears the field so the
// caller can persist NULL into a nullable column.

interface NumberFieldProps {
  label: string;
  value: number | null;
  onChange: (v: number | null) => void;
  placeholder?: string;
  hint?: string;
  min?: number;
  max?: number;
  step?: number;
  prefix?: string;
  suffix?: string;
  disabled?: boolean;
  required?: boolean;
}

export function NumberField({
  label,
  value,
  onChange,
  placeholder,
  hint,
  min,
  max,
  step,
  prefix,
  suffix,
  disabled,
  required,
}: NumberFieldProps) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-medium uppercase tracking-wide text-[color:var(--bo-mute)]">
        {label}
        {required ? <span className="ms-0.5 text-[#9f1239]">*</span> : null}
      </span>
      <div className="flex items-center gap-2">
        {prefix ? (
          <span className="text-[12px] text-[color:var(--bo-mute)]">{prefix}</span>
        ) : null}
        <input
          type="number"
          inputMode="decimal"
          value={value == null ? '' : String(value)}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === '') {
              onChange(null);
              return;
            }
            const n = Number(raw);
            onChange(Number.isFinite(n) ? n : null);
          }}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          className="h-10 w-full rounded-md border border-[color:var(--bo-line)] bg-white px-3 text-[13px] tabular-nums text-[color:var(--bo-ink)] focus:border-[color:var(--bo-mute)] focus:outline-none disabled:cursor-not-allowed disabled:bg-[color:var(--bo-bg)]"
        />
        {suffix ? (
          <span className="text-[12px] text-[color:var(--bo-mute)]">{suffix}</span>
        ) : null}
      </div>
      {hint ? <span className="text-[11px] text-[color:var(--bo-mute)]">{hint}</span> : null}
    </label>
  );
}
